import React, { Fragment, useEffect, useState } from 'react';
import Managers from './managers/managers';
import PartnerBankDetails from './partner-bank-details';
import PartnerInfoHeader from './partner-info-header';
import RidersInfo from './rider-info';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { PartnerType } from 'models/partner.model';
import { RiderType } from 'models/rider.model';
import { apiService } from 'utils/api';

type Props = {
  partner: PartnerType | undefined;
  onClose: () => void;
};
const PartnerInfo = ({ partner, onClose }: Props) => {
  if (!partner) return <span />;
  const [loading, setLoading] = useState(true);
  const [riders, setRiders] = useState<RiderType[]>([]);
  const [managers, setManagers] = useState<RiderType[]>([]);
  const loadPartnerData = async () => {
    setLoading(true);
    const res = await apiService.post(`logistics/delivery-partner/${partner.id}/riders`, {
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    if (res.data) {
      setRiders(res.data.riders.filter((user: RiderType) => user.role === 'RIDER'));
      setManagers(res.data.riders.filter((user: RiderType) => user.role === 'LOGISTICS_ADMIN'));
    }
    setLoading(false);
  };

  useEffect(() => {
    loadPartnerData();
  }, [partner]);

  return (
    <BaseModal
      position='right'
      isOpen={true}
      onRequestClose={onClose}
      size='wide'
      title={partner.name}>
      {loading ? (
        <div className='flex h-[50vh] items-center justify-center'>
          <h2 className='text-xl font-bold'>Loading data...</h2>
        </div>
      ) : (
        <Fragment>
          <div className='border border-[#E9EBEC] px-7 py-4 rounded-lg lg:max-h-[400px] overflow-auto mb-6'>
            <PartnerInfoHeader
              onlineRidersCount={riders.filter((rider) => rider.online).length}
              count={riders.length}
            />
            <RidersInfo riders={riders} onReloadRiders={loadPartnerData} />
          </div>
          <div className='my-5'>
            <PartnerBankDetails partner={partner} />
          </div>
          <Managers count={managers.length} managers={managers} />
        </Fragment>
      )}
    </BaseModal>
  );
};

export default PartnerInfo;
